import { WEBSOCKET_STATE } from "../websocket/webSocketState";

export function deriveChatMessageProps({
  type,
  status,
  content,
  imageUrls,
  imageThumbnailUrls,
  imageUrl,
  imageFileNames,
  fileAttachments,
  fileName,
  fileExtension,
  fileUrl,
  body,
}) {
  const isMy = type === "my";

  const fileRows =
    Array.isArray(fileAttachments) && fileAttachments.length > 0
      ? fileAttachments
      : fileName != null || fileExtension != null || fileUrl != null
        ? [{ fileName, fileExtension, fileUrl }]
        : [];

  const resolvedUrls =
    Array.isArray(imageUrls) && imageUrls.length > 0
      ? imageUrls
      : imageUrl
        ? [imageUrl]
        : [];

  const resolvedThumbnailUrls = resolvedUrls.map((url, i) =>
    Array.isArray(imageThumbnailUrls) && imageThumbnailUrls[i] ? imageThumbnailUrls[i] : url
  );

  const resolvedImageNames = resolvedUrls.map((_, i) =>
    Array.isArray(imageFileNames) && imageFileNames[i] != null && imageFileNames[i] !== ""
      ? imageFileNames[i]
      : null
  );

  const hasContent = Boolean(
    content && String(content.contentId ?? "").trim() && String(content.contentType ?? "").trim()
  );

  const hasFile = fileRows.length > 0;
  const isPending = status === WEBSOCKET_STATE.PENDING;
  const isFailed = status === WEBSOCKET_STATE.FAILED;

  const hasRenderableBody =
    hasContent ||
    resolvedUrls.length > 0 ||
    hasFile ||
    (body != null && body !== "");

  return {
    isMy,
    fileRows,
    hasFile,
    resolvedUrls,
    resolvedThumbnailUrls,
    resolvedImageNames,
    hasContent,
    isPending,
    isFailed,
    hasRenderableBody,
  };
}

export function buildFrameBodyClassName(styles, isPending, isFailed) {
  return `${styles.frameBody} ${isFailed ? styles.frameBodyDimmedFailed : isPending ? styles.frameBodyDimmedPending : ""}`.trim();
}
